import { snapshotConfiguratorPreview } from "./snapshotPreview";

/**
 * Sélecteurs des noeuds preview par kind de produit configurable.
 * Utilisés pour repérer automatiquement le bon noeud à capturer selon
 * le contexte d'appel.
 */
const PREVIEW_SELECTORS = {
  cross: "[data-testid='cross-preview']",
  letters: "[data-testid='boxletter-preview']",
  caducee: "[data-testid='caducee-preview']",
};

/** Devine le kind à partir du slug produit. */
function guessKindFromSlug(slug) {
  const s = String(slug || "");
  if (s.startsWith("croix-")) return "cross";
  if (s === "caducee") return "caducee";
  if (s.startsWith("lettre-") || s.startsWith("enseigne-")) return "letters";
  return null;
}

/**
 * Capture la miniature du produit actuellement affiché dans le configurateur.
 *
 * Options :
 * - `slug` : slug du produit (utilisé pour deviner le kind si non fourni)
 * - `kind` : "cross" | "letters" | "caducee" (prioritaire sur slug)
 *
 * Compression : max 400px de large + qualité JPEG 0.75 → ~15-30 KB au lieu
 * de ~200 KB. Réduit la pression sur localStorage (limite ~5 MB) pour
 * supporter des paniers avec beaucoup d'articles.
 *
 * Retourne un data-URL JPEG ou null si le noeud n'est pas trouvé / capture échoue.
 */
export async function captureCurrentPreview({ slug, kind } = {}) {
  try {
    const resolvedKind = kind || guessKindFromSlug(slug);
    const selector = PREVIEW_SELECTORS[resolvedKind];
    if (!selector) return null;
    const node = document.querySelector(selector);
    if (!node) return null;
    // Compression : maxWidth=400 + quality=0.75 (JPEG) → miniature légère
    // adaptée à un affichage 128x128 dans le panier.
    return await snapshotConfiguratorPreview(node, {
      maxWidth: 400,
      quality: 0.75,
    });
  } catch {
    return null;
  }
}
